export default __webpack_public_path__ + "static/media/virtual-bg4.6382f88d.png";